// @flow
import styled from 'styled-components';

import {
  px, py, mx
} from 'styled-components-spacing';

import breakpoint from 'styled-components-breakpoint';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from '@theme';
import Select from 'react-select';

const { colors } = theme;

export const StyledForm = styled.form`
  display: flex;
  height: 29px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  position: relative;
  box-shadow: 0 5px 3px 0px ${colors.transluscentDark};
  ${mx(0)}
  ${({ setted }) =>
    (setted
      ? `
    color: ${colors.darkBlue};
    background-color: ${colors.white};
  `
      : `
    color: ${colors.darkBlue};
    background-color: ${colors.white};
  `)}
 // If IE
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: 1;
  }

  ${px(0)}
  ${py(0)}

  ${breakpoint('mobile')`
    width: 100%;
    ${py(0)}
  `}

  ${breakpoint('tablet')`
  height: 40px;
  width: 80%;

  `}
    ${breakpoint('desktop')`
    ${mx(0)}
    width: calc(70% - 3.1rem);
    height: 50px;
  `}

`;

export const StyledSelectInput = styled(Select)`
  color: ${colors.darkBlue};
  border: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 29px;
  ::-ms-expand {
    display: none;
  }

  ${breakpoint('mobile', 'desktop')`
    font-size: 14px;
`}

  width: 100%;

  & > .react-select__option {
    color: ${colors.darkBlue};
  }
  .react-select-container .react-select__control .react-select__indicators {
    display: none;
    width: 100%;
  }

  #react-select-2-listbox {
    width: calc(100% - 20px);
    ${breakpoint('mobile')`
      margin-top: 0;
    `}
  }
  .css-1okebmr-indicatorSeparator {
    display: none;
  }
`;

export const StyledIconWrapper = styled.div`
  position: absolute;
  right: 0;
  ${px(3)}
  pointer-events: none;
  z-index: 10;
`;

export const StyledIcon = styled(FontAwesomeIcon)`
  color: inherit;
  pointer-events: none;
`;
